import { render, staticRenderFns } from "./CloudRec.vue?vue&type=template&id=0afa5998&"
import script from "./CloudRec.vue?vue&type=script&lang=js&"
export * from "./CloudRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports